import {Component, OnInit, ViewChild} from "@angular/core";
import {EventTypes} from "../../models/event-type.model";
import {EventsService} from "../../services";
import {BsModalComponent} from 'ng2-bs3-modal/ng2-bs3-modal';


@Component({
    selector: 'app-eventtypes',
    templateUrl: './eventtypes.component.html',
    providers: [EventsService]
})
export class EventtypesComponent implements OnInit {
    @ViewChild('eventTypesModal',{static: false}) eventTypesModal: BsModalComponent;
    selectedType: EventTypes = new EventTypes();
    types: EventTypes[] = [];
    showLoadScreen: boolean = false;

    constructor(private eventsService: EventsService) {
        this.eventsService.onStart = () => this.showLoadScreen = true;
        this.eventsService.onEnd = () => this.showLoadScreen = false;
    }

    ngOnInit() {
        this.eventsService.getTypesList().subscribe((data) => {
            this.types = data.data;

        });
    }

    open(eventtype: any) {
        if (eventtype != undefined) {
            this.selectedType = eventtype;
            this.eventTypesModal.open();
        }
    }

    changeEventType(event) {
        return this.eventsService.changeEventType(event).subscribe((data) => {
            if (data.status)
                this.eventTypesModal.close();
        });
    }

    close() {
        this.eventTypesModal.close();
    }


}
